import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getCookieConsentValue } from 'react-cookie-consent';
import ReactGA from 'react-ga';
import GenericError from './components/organisms/GenericError';
import hotjar from './services/util/hotjar';
import AlertaCookie from './components/organisms/AlertaCookie';

const LayoutWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function ThirtyPartyCookieProvider({ children }) {
  const cookieName = 'cookieSimulador';
  const [isCookiesGranted, setIsCookiesGranted] = useState(
    () => getCookieConsentValue(cookieName) === 'true'
  );

  if (isCookiesGranted && process.env.NODE_ENV === 'production') {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
    ReactGA.pageview(window.location.pathname);
    hotjar.initialize(
      process.env.REACT_APP_HOTJAR_ID,
      process.env.REACT_APP_HOTJAR_VERSION
    );
  }

  const childContent = (
    <>
      {children}
      <AlertaCookie
        cookieName={cookieName}
        onAccept={() => setIsCookiesGranted(true)}
      />
    </>
  );

  if (navigator.cookieEnabled) {
    return childContent;
  }

  return (
    <LayoutWrapper>
      <GenericError imageSrc="https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/seguros/feedback/cookies-warning.svg">
        <p>
          Verificamos que você desabilitou os cookies.
          <br />
          Habilite essa opção nas configurações do seu navegador para utilizar o
          sistema.
        </p>
      </GenericError>
    </LayoutWrapper>
  );
}

ThirtyPartyCookieProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThirtyPartyCookieProvider;
